/* Inline variant picking on homepage product cards */
(function () {
  function setup(box) {
    var card = box.closest('[data-ssh-card]');
    var btn = card.querySelector('[data-ssh-cta]');
    var img = card.querySelector('[data-ssh-img]');
    var variants = [];
    try { variants = JSON.parse(box.querySelector('[data-ssh-variants]').textContent); } catch (e) { return; }
    var groups = Array.prototype.slice.call(box.querySelectorAll('[data-ssh-opt]'));
    var n = variants.length ? variants[0].o.length : 0;

    function current() {
      var sel = new Array(n).fill(null);
      groups.forEach(function (g) {
        var i = parseInt(g.getAttribute('data-ssh-opt'), 10);
        if (g.tagName === 'SELECT' || g.tagName === 'INPUT') sel[i] = g.value;
        else { var on = g.querySelector('[aria-checked="true"]'); sel[i] = on ? on.getAttribute('data-val') : null; }
      });
      return sel;
    }
    function match(sel, ignore) {
      return variants.filter(function (v) {
        return v.o.every(function (val, i) { return i === ignore || sel[i] === null || sel[i] === val; });
      });
    }
    function refresh(swap) {
      var sel = current();
      /* grey out chips that have no in-stock variant with the other picks */
      groups.forEach(function (g) {
        if (g.tagName === 'SELECT' || g.tagName === 'INPUT') return;
        var i = parseInt(g.getAttribute('data-ssh-opt'), 10);
        g.querySelectorAll('.ssh-chip').forEach(function (c) {
          var test = sel.slice(); test[i] = c.getAttribute('data-val');
          var ok = match(test, -1).some(function (v) { return v.a && v.o[i] === test[i]; });
          c.disabled = !ok;
          if (!ok && c.getAttribute('aria-checked') === 'true') c.setAttribute('aria-checked', 'false');
        });
      });
      sel = current();
      var missing = sel.indexOf(null) !== -1;
      var hit = missing ? null : variants.filter(function (v) { return v.o.every(function (val, i) { return sel[i] === val; }); })[0];
      if (missing) { btn.disabled = true; btn.setAttribute('data-ssh-add', ''); btn.textContent = 'Pick a size'; }
      else if (!hit || !hit.a) { btn.disabled = true; btn.setAttribute('data-ssh-add', ''); btn.textContent = 'Sold out'; }
      else { btn.disabled = false; btn.setAttribute('data-ssh-add', hit.id); btn.textContent = btn.getAttribute('data-ssh-label') || 'Add to cart'; }
      /* swap photo when the color changes */
      var pic = (hit && hit.img) || (match(sel, -1).filter(function (v) { return v.img; })[0] || {}).img;
      var base = function (u) { return (u || '').split('?')[0].replace(/^https?:/, '').replace(/_\d+x(\.\w+)$/, '$1'); };
      if (swap && img && pic && base(pic) !== base(img.currentSrc || img.src)) { img.removeAttribute('srcset'); img.src = pic; }
    }
    box.addEventListener('click', function (e) {
      var c = e.target.closest('.ssh-chip');
      if (!c || c.disabled) return;
      c.parentNode.querySelectorAll('.ssh-chip').forEach(function (x) { x.setAttribute('aria-checked', x === c ? 'true' : 'false'); });
      refresh(true);
    });
    box.addEventListener('change', function () { refresh(true); });
    refresh();
  }
  document.querySelectorAll('[data-ssh-opts]').forEach(setup);
})();
